import { SubjectRole } from "../generated/graphql"

/**
 * Policy class for managing access to well-related resources.
 *
 * This class is implemented using the "static class" pattern commonly seen in other languages.
 * All methods are static, and the constructor is private to prevent instantiation.
 *
 * Use this class directly (e.g., Policy_Well.AddWell(...)) to check well-related permissions  based on the user's role.
 */
class Policy_Well {
    private constructor() {
        return
    }

    static AddWell(viewerRole: SubjectRole): boolean {
        return [SubjectRole.PpoAdmin, SubjectRole.OrgAdmin].includes(viewerRole)
    }
}

export { Policy_Well }
